import { Pipe, PipeTransform } from '@angular/core';
import { ValidationEnum } from './validation-enum.model';

@Pipe({
  name: 'validationToString'
})
export class ValidationToString implements PipeTransform {

  transform(value: string): string {
    if (ValidationEnum[value]) {
      return ValidationEnum[value];
    } else {
      return value;
    }
  }

}
